/**
 * Generates a consistent color for a given string (e.g., identityId)
 * The same string will always produce the same color
 */
export const getConsistentColor = (str: string): string => {
  if (!str) return '#9e9e9e'; // Default gray for empty values

  // Generate a hash from the string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  // Define a palette of pleasant, distinguishable colors
  const colors = [
    '#1976d2',
    '#388e3c',
    '#d32f2f',
    '#f57c00',
    '#7b1fa2',
    '#c2185b',
    '#0097a7',
    '#689f38',
    '#e64a19',
    '#5d4037',
    '#455a64',
    '#00796b',
    '#fbc02d',
    '#512da8',
    '#0288d1',
  ];

  // Use the hash to select a color from the palette
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};
